module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[118]605.11a0fcc.woff2";